/* ============================================================================
   CLARA CART UPSELLS  (assets/clark-cart-upsells.js)  - based on the CLARK cart kit
   ----------------------------------------------------------------------------
   Adds these to the cart drawer from snippets/clark-cart-drawer.liquid:
     1. a delivery notice strip                    (top of the item list)
     2. a free-shipping / free-gift progress bar   (under the strip)
     3. a "You May Also Like" row                  (bottom of the item list)
     4. an automatic FREE GIFT: when the cart (gift excluded) reaches
        freeGiftThreshold the gift is added by itself, and removed again if the
        cart drops back below it.

   EDIT THE SETTINGS BELOW.  Money values are in CENTS:
       350000 = Rs. 3,500       1000000 = Rs. 10,000

   The free gift is variant 51064439013508 = SKU JBX-BLK, product
   "Order above Rs. 10,000 - Free Gift" (handle free-gift-1, priced Rs. 0).
   Note: the SKU JBX-BLK is ALSO used by a second variant (Zipper Jewelry Box,
   Black, Rs. 999) - that is why the variant ID is used here, not the SKU.

   Needs: #drawerCart, #drawerCartBody, #drawerCartFooter, #drawerCartSubtotal
   and window.DrawerCart (all provided by clark-cart-drawer.liquid).
   ============================================================================ */
var CLARK_UPSELLS = {
  currencyLabel: 'Rs.',             /* text shown before amounts */
  freeShippingThreshold: 350000,    /* free shipping milestone (Rs. 3,500) */
  freeGiftThreshold: 1000000,       /* free gift milestone (Rs. 10,000) */
  freeGiftVariantId: 51064439013508,/* SKU JBX-BLK -> "Order above Rs. 10,000 - Free Gift" */
  freeGiftHandle: 'free-gift-1',    /* hidden from "You May Also Like" */
  recsTitle: 'You May Also Like',
  recsLimit: 8,                     /* max products in the row */
  recsFallbackCollection: 'shop-all', /* used when Shopify has too few related products */
  recsExcludeHandles: [],           /* extra product handles to never recommend */
  deliveryMessages: [               /* top strip; 2+ messages adds < > arrows */
    'Delivery: Karachi 2\u20134 days \u00B7 Nationwide 4\u20136 days.',
    '1 Year Color Warranty on every piece.'
  ]
};

/* engine */

(function () {
  'use strict';
  var cfg = window.CLARK_UPSELLS || {};
  var CUR = (cfg.currencyLabel != null) ? cfg.currencyLabel : 'Rs.';
  var FREE_SHIP = cfg.freeShippingThreshold || 350000;
  var FREE_GIFT = cfg.freeGiftThreshold || 1000000;
  var GIFT_ID = parseInt(cfg.freeGiftVariantId, 10) || 0;
  var GIFT_HANDLE = cfg.freeGiftHandle || '';
  var GIFT_PROP = '_free_gift';
  var RECS_TITLE = cfg.recsTitle || 'You May Also Like';
  var RECS_LIMIT = cfg.recsLimit || 8;
  var RECS_FALLBACK = cfg.recsFallbackCollection || '';
  var RECS_EXCLUDE = (cfg.recsExcludeHandles || []).concat(GIFT_HANDLE ? [GIFT_HANDLE] : []);
  var MESSAGES = (cfg.deliveryMessages && cfg.deliveryMessages.length) ? cfg.deliveryMessages : ['Free shipping on orders above Rs. 3,500.'];

  var CSS = ''
    /* ---- delivery strip + progress bar ---- */
    + '#clark-top{margin:-16px -24px 8px}'
    + '#clark-notice-strip{display:flex;align-items:stretch;background:#333;color:#fff;font-size:10px;letter-spacing:.02em;text-align:center}'
    + '#clark-notice-strip .clark-notice-text{flex:1;padding:10px 12px;line-height:1.3}'
    + '#clark-notice-strip .clark-narrow{background:#555;border:0;color:#fff;font-size:18px;cursor:pointer;line-height:1;width:36px;padding:0}'
    + '#clark-ship-bar{padding:12px 24px 6px}'
    + '.clark-ship-text{text-align:center;font-size:11px;letter-spacing:.01em;color:#555;margin:0 0 18px;line-height:1.3}'
    + '.clark-track{position:relative;height:5px;background:#e0e0e0;border-radius:99px;margin:0 14px}'
    + '.clark-fill{position:absolute;left:0;top:0;bottom:0;background:#333;border-radius:99px;transition:width .5s ease;max-width:100%}'
    + '.clark-marker{position:absolute;top:50%;transform:translate(-50%,-50%);width:28px;height:28px;border-radius:50%;background:#e0e0e0;display:flex;align-items:center;justify-content:center}'
    + '.clark-marker.done{background:#333}'
    + '.clark-marker svg{width:14px;height:14px;fill:none;stroke:#333;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}'
    + '.clark-marker.done svg{stroke:#fff}'
    + '.clark-labels{position:relative;height:14px;margin:14px 14px 0;font-size:9.5px;letter-spacing:.01em;color:#555}'
    + '.clark-labels span{position:absolute;top:0;transform:translateX(-50%);white-space:nowrap}'
    /* ---- "You May Also Like" ---- */
    + '#clark-recs{margin-top:16px;padding-top:16px;border-top:1px solid #e0e0e0}'
    + '.clark-recs-title{margin:0 0 12px;font-size:13px;font-weight:600;letter-spacing:0;color:#111;text-align:left}'
    + '.clark-recs-row{display:flex;gap:12px;overflow-x:auto;scroll-snap-type:x proximity;padding-bottom:6px;-webkit-overflow-scrolling:touch}'
    + '.clark-rec{flex:0 0 128px;scroll-snap-align:start;display:flex;flex-direction:column;gap:6px;letter-spacing:0}'
    + '.clark-rec-img{display:block;width:128px;height:128px;object-fit:cover;border-radius:8px;background:#f3f3f3}'
    + '.clark-rec-name{font-size:11px;line-height:1.3;color:#111;text-decoration:none;min-height:29px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-transform:none}'
    + '.clark-rec-price{font-size:11px;color:#555}'
    + '.clark-rec-btn{display:block;background:#000;color:#fff;border:0;border-radius:6px;padding:6px 0;font-size:10px;font-weight:600;letter-spacing:.02em;cursor:pointer;text-align:center;text-decoration:none;width:100%}'
    + '.clark-rec-btn:disabled{opacity:.55;cursor:default}';

  var TRUCK_SVG = '<svg viewBox="0 0 24 24"><path d="M1 7h13v9H1z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="6" cy="18.5" r="1.8"/><circle cx="17.5" cy="18.5" r="1.8"/></svg>';
  var GIFT_SVG = '<svg viewBox="0 0 24 24"><rect x="3" y="8" width="18" height="4"/><path d="M5 12v8h14v-8"/><path d="M12 8v12"/><path d="M12 8C8 8 6.5 6.5 6.5 4.8 6.5 3.4 7.5 2.5 9 2.5c1.6 0 3 2.6 3 5.5z"/><path d="M12 8c4 0 5.5-1.5 5.5-3.2 0-1.4-1-2.3-2.5-2.3-1.6 0-3 2.6-3 5.5z"/></svg>';

  /* ------------------------------------------------------------------ helpers */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fmtMoney(cents, decimals) {
    var v = cents / 100;
    var s = v.toLocaleString('en-US', { minimumFractionDigits: decimals ? 2 : 0, maximumFractionDigits: decimals ? 2 : 0 });
    return CUR + s;
  }

  function ensureCss() {
    if (document.getElementById('clark-upsells-css')) return;
    var st = document.createElement('style');
    st.id = 'clark-upsells-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  /* While our own code changes the cart, tell clark-cart-bridge.js not to react
     (otherwise it would re-open the drawer / re-check the gift for every call). */
  function silent(fn) {
    window.__clarkSilent = (window.__clarkSilent || 0) + 1;
    var done = function () { window.__clarkSilent = Math.max(0, (window.__clarkSilent || 1) - 1); };
    return fn().then(function (v) { done(); return v; }, function (e) { done(); throw e; });
  }

  function refreshDrawer() {
    try {
      if (window.DrawerCart && typeof window.DrawerCart.refresh === 'function') {
        return window.DrawerCart.refresh();
      }
    } catch (e) { console.warn('[clark-upsells] drawer refresh failed', e); }
    return Promise.resolve();
  }

  /* ------------------------------------------------------------ free gift */
  function isGiftLine(it) {
    return (GIFT_ID && it.variant_id === GIFT_ID) || !!(it.properties && it.properties[GIFT_PROP] === 'true');
  }

  /* cart value (in cents) WITHOUT the gift line(s) - this is what the milestones measure */
  function subtotalExGift(cart) {
    var c = 0;
    (cart.items || []).forEach(function (it) {
      if (!isGiftLine(it)) c += (it.final_line_price != null ? it.final_line_price : it.line_price) || 0;
    });
    return c;
  }

  var giftBusy = false, giftFailed = false;

  /* Adds the gift when the cart qualifies, removes it when it no longer does, keeps it at quantity 1.
     Resolves true when it changed the cart. */
  function ensureFreeGift(cart) {
    if (!GIFT_ID || giftBusy) return Promise.resolve(false);
    var qualifies = subtotalExGift(cart) >= FREE_GIFT;
    var lines = (cart.items || []).filter(isGiftLine);
    var job = null;

    if (!qualifies) giftFailed = false; /* allow a retry next time the cart qualifies */

    if (qualifies && !lines.length) {
      if (giftFailed) return Promise.resolve(false);
      job = function () {
        var item = { id: GIFT_ID, quantity: 1, properties: {} };
        item.properties[GIFT_PROP] = 'true';
        return postJSON('/cart/add.js', { items: [item] }).then(function (r) {
          if (!r.ok) throw new Error('gift add failed (' + r.status + ')');
          return true;
        });
      };
    } else if (!qualifies && lines.length) {
      job = function () {
        return Promise.all(lines.map(function (l) { return postJSON('/cart/change.js', { id: l.key, quantity: 0 }); }))
          .then(function () { return true; });
      };
    } else if (qualifies && lines.length && (lines.length > 1 || lines[0].quantity !== 1)) {
      job = function () {
        var reqs = [postJSON('/cart/change.js', { id: lines[0].key, quantity: 1 })];
        lines.slice(1).forEach(function (l) { reqs.push(postJSON('/cart/change.js', { id: l.key, quantity: 0 })); });
        return Promise.all(reqs).then(function () { return true; });
      };
    }
    if (!job) return Promise.resolve(false);

    giftBusy = true;
    return silent(job).catch(function (err) {
      console.warn('[clark-upsells]', err);
      if (qualifies && !lines.length) giftFailed = true; /* e.g. gift out of stock: do not retry in a loop */
      return false;
    }).then(function (changed) { giftBusy = false; return changed; });
  }

  /* ------------------------------------------------- You May Also Like data */
  function absUrl(u) {
    if (!u) return '';
    if (typeof u === 'object') u = u.src || u.url || '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u;
  }
  function sized(u, w) {
    u = absUrl(u);
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 300);
  }
  /* numbers are cents (recommendations / product.js), strings are decimals (products.json) */
  function toCents(v) {
    if (typeof v === 'number') return Math.round(v);
    var f = parseFloat(v);
    return isNaN(f) ? 0 : Math.round(f * 100);
  }

  function normRec(p) {
    if (!p || !p.variants || !p.variants.length) return null;
    var avail = p.variants.filter(function (v) { return v.available; });
    if (!avail.length) return null;
    var v = avail[0];
    var img = p.featured_image || (p.images && p.images[0]) || (v.featured_image && v.featured_image.src) || '';
    return {
      id: p.id,
      handle: p.handle,
      title: p.title,
      url: '/products/' + p.handle,
      image: sized(img, 300),
      price: toCents(v.price),
      variantId: v.id,
      variantIds: p.variants.map(function (x) { return x.id; }),
      multi: p.variants.length > 1
    };
  }

  var recsCache = {};
  function getRecs(seedProductId) {
    var key = String(seedProductId || 'none');
    if (!recsCache[key]) {
      var related = seedProductId
        ? fetch('/recommendations/products.json?product_id=' + seedProductId + '&limit=' + (RECS_LIMIT + 6) + '&intent=related', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.json() : { products: [] }; })
            .then(function (j) { return (j.products || []).map(normRec).filter(Boolean); })
            .catch(function () { return []; })
        : Promise.resolve([]);
      recsCache[key] = related.then(function (list) {
        if (list.length >= RECS_LIMIT || !RECS_FALLBACK) return list;
        return fetch('/collections/' + RECS_FALLBACK + '/products.json?limit=30', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (j) {
            var seen = {};
            list.forEach(function (x) { seen[x.id] = true; });
            (j.products || []).map(normRec).filter(Boolean).forEach(function (x) { if (!seen[x.id]) list.push(x); });
            return list;
          })
          .catch(function () { return list; });
      });
    }
    return recsCache[key];
  }

  /* ------------------------------------------------------------- the blocks */
  /* the drawer rewrites the item list's HTML on every change, which wipes our blocks;
     keep the last copies so they can be put back instantly (see reinsertBlocks) */
  var lastWrap = null, lastRecs = null;
  function removeBlocks() {
    ['clark-top', 'clark-notice-strip', 'clark-ship-bar', 'clark-recs'].forEach(function (id) {
      var e = document.getElementById(id);
      if (e) e.remove();
    });
    lastWrap = null;
    lastRecs = null;
  }

  var noticeIdx = 0;
  function ensureNotice(host) {
    var el = document.getElementById('clark-notice-strip');
    if (!el || !host.contains(el)) {
      if (el) el.remove();
      el = document.createElement('div');
      el.id = 'clark-notice-strip';
      el.innerHTML = '<button type="button" class="clark-narrow" data-nprev aria-label="Previous message">\u2039</button>'
        + '<span class="clark-notice-text"></span>'
        + '<button type="button" class="clark-narrow" data-nnext aria-label="Next message">\u203A</button>';
      host.insertBefore(el, host.firstChild);
    }
    el.querySelector('.clark-notice-text').textContent = MESSAGES[noticeIdx % MESSAGES.length];
    var multi = MESSAGES.length > 1;
    el.querySelector('[data-nprev]').style.display = multi ? '' : 'none';
    el.querySelector('[data-nnext]').style.display = multi ? '' : 'none';
  }

  function buildProgress(cart) {
    var subtotal = Math.max(0, subtotalExGift(cart));
    /* two equal halves: 0 -> free shipping fills the first half, free shipping -> free gift the second,
       so the truck marker always sits in the middle of the bar */
    var shipPct = 50;
    var pct;
    if (subtotal >= FREE_GIFT) pct = 100;
    else if (subtotal >= FREE_SHIP) pct = 50 + ((subtotal - FREE_SHIP) / Math.max(1, FREE_GIFT - FREE_SHIP)) * 50;
    else pct = (subtotal / Math.max(1, FREE_SHIP)) * 50;
    var shipDone = subtotal >= FREE_SHIP;
    var giftDone = subtotal >= FREE_GIFT;
    var text;
    if (giftDone) text = 'Free shipping + free gift unlocked!';
    else if (shipDone) text = 'You are ' + fmtMoney(FREE_GIFT - subtotal) + ' away from Free Gift';
    else text = 'You are ' + fmtMoney(FREE_SHIP - subtotal) + ' away from Free shipping';
    var bar = document.createElement('div');
    bar.id = 'clark-ship-bar';
    bar.innerHTML = '<p class="clark-ship-text">' + text + '</p>'
      + '<div class="clark-track"><div class="clark-fill" style="width:' + pct + '%"></div>'
      + '<span class="clark-marker' + (shipDone ? ' done' : '') + '" style="left:' + shipPct + '%">' + TRUCK_SVG + '</span>'
      + '<span class="clark-marker' + (giftDone ? ' done' : '') + '" style="left:100%">' + GIFT_SVG + '</span></div>'
      + '<div class="clark-labels"><span style="left:' + shipPct + '%">Free shipping</span><span style="left:100%">Free Gift</span></div>';
    return bar;
  }

  /* "You May Also Like": products related to what is in the cart, minus what is already in it */
  function buildRecs(cart, list) {
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.product_id] = true; });
    var items = (list || []).filter(function (r) {
      if (inCart[r.id]) return false;
      if (RECS_EXCLUDE.indexOf(r.handle) > -1) return false;
      if (GIFT_ID && r.variantIds.indexOf(GIFT_ID) > -1) return false;
      return true;
    }).slice(0, RECS_LIMIT);
    if (!items.length) return null;

    var h = '<p class="clark-recs-title"></p><div class="clark-recs-row">';
    items.forEach(function (r) {
      h += '<div class="clark-rec">'
        + '<a href="' + esc(r.url) + '">' + (r.image ? '<img class="clark-rec-img" src="' + esc(r.image) + '" alt="" loading="lazy">' : '') + '</a>'
        + '<a class="clark-rec-name" href="' + esc(r.url) + '">' + esc(r.title) + '</a>'
        + '<span class="clark-rec-price">' + fmtMoney(r.price, r.price % 100 !== 0) + '</span>'
        + (r.multi
            ? '<a class="clark-rec-btn" href="' + esc(r.url) + '">Options</a>'
            : '<button type="button" class="clark-rec-btn" data-rec-add="' + esc(r.variantId) + '">+ Add</button>')
        + '</div>';
    });
    var el = document.createElement('div');
    el.id = 'clark-recs';
    el.innerHTML = h + '</div>';
    el.querySelector('.clark-recs-title').textContent = RECS_TITLE;
    return el;
  }

  var syncing = false, queued = false, lastDomSig = null;
  function sync() {
    if (syncing) { queued = true; return; }

    var drawerEl = document.getElementById('drawerCart');
    var bodyEl = document.getElementById('drawerCartBody');
    var footerEl = document.getElementById('drawerCartFooter');
    if (!drawerEl || !bodyEl || !footerEl) return;

    /* cheap DOM signature: only re-render when the drawer contents actually changed */
    var rows = bodyEl.querySelectorAll('.drawer-cart__item, .drawer-cart__bundle').length;
    var subEl = document.getElementById('drawerCartSubtotal');
    var domSig = rows + '|' + (subEl ? (subEl.textContent || '').replace(/\s+/g, '') : '');
    if (domSig === lastDomSig && (document.getElementById('clark-ship-bar') || !rows)) return;
    if (!rows) { lastDomSig = domSig; removeBlocks(); return; }

    syncing = true;
    ensureCss();
    var finish = function () { syncing = false; if (queued) { queued = false; sync(); } };

    getCart().then(function (cart) {
      lastDomSig = domSig;
      if (!cart || !cart.item_count) { removeBlocks(); finish(); return; }

      /* free gift first: if it changed the cart, re-draw the drawer; sync() runs again from that */
      ensureFreeGift(cart).then(function (changed) {
        if (changed) { finish(); refreshDrawer(); return; }

        var seed = (cart.items || []).filter(function (it) { return !isGiftLine(it); })[0];
        var done = false;
        function render(list) {
          if (done) return;
          done = true;
          try {
            /* strip + progress bar: top of the scrolling item list */
            var wrap = document.getElementById('clark-top');
            if (!wrap || !bodyEl.contains(wrap)) {
              if (wrap) wrap.remove();
              wrap = document.createElement('div');
              wrap.id = 'clark-top';
              bodyEl.insertBefore(wrap, bodyEl.firstChild);
            }
            lastWrap = wrap;
            ensureNotice(wrap);
            var oldBar = document.getElementById('clark-ship-bar'); if (oldBar) oldBar.remove();
            wrap.appendChild(buildProgress(cart));

            /* "You May Also Like": bottom of the scrolling item list */
            var oldRecs = document.getElementById('clark-recs'); if (oldRecs) oldRecs.remove();
            var recsEl = buildRecs(cart, list);
            if (recsEl) bodyEl.appendChild(recsEl);
            lastRecs = recsEl;
          } catch (e) { console.warn('[clark-upsells] render failed', e); }
          finish();
        }
        /* don't hold the strip + bar back if the recommendations are slow to load */
        var tm = setTimeout(function () { render(null); }, 2500);
        getRecs(seed && seed.product_id).then(function (list) {
          clearTimeout(tm);
          if (done) { if (list && list.length) { lastDomSig = null; schedule(); } return; }
          render(list);
        }, function () { clearTimeout(tm); render(null); });
      });
    }).catch(function (e) { console.warn('[clark-upsells] cart read failed', e); finish(); });
  }

  function addRec(btn) {
    var id = parseInt(btn.getAttribute('data-rec-add'), 10);
    if (!id) return;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    silent(function () {
      return postJSON('/cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(function (r) {
        if (!r.ok) throw new Error('add failed (' + r.status + ')');
        return refreshDrawer();
      });
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = '+ Add';
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-nprev],[data-nnext],[data-rec-add]') : null;
    if (!t) return;
    if (t.hasAttribute('data-nprev') || t.hasAttribute('data-nnext')) {
      noticeIdx = (noticeIdx + (t.hasAttribute('data-nnext') ? 1 : MESSAGES.length - 1)) % MESSAGES.length;
      var tx = document.querySelector('#clark-notice-strip .clark-notice-text');
      if (tx) tx.textContent = MESSAGES[noticeIdx];
    } else if (t.hasAttribute('data-rec-add')) {
      addRec(t);
    }
  });

  var deb = null;
  function schedule() { clearTimeout(deb); deb = setTimeout(sync, 60); }

  /* The drawer rewrites the item list's HTML on every change, which wipes our blocks.
     Put the previous copies back immediately (before the browser paints) so nothing flickers;
     sync() then refreshes them. */
  function reinsertBlocks() {
    var b = document.getElementById('drawerCartBody');
    if (!b) return;
    if (!b.querySelector('.drawer-cart__item, .drawer-cart__bundle')) return;
    if (lastWrap && !b.contains(lastWrap)) b.insertBefore(lastWrap, b.firstChild);
    if (lastRecs && !b.contains(lastRecs)) b.appendChild(lastRecs);
  }

  /* Public: used by clark-cart-bridge.js after cart changes made outside the drawer
     (product page, cart page, quick add...). On the /cart page the page is reloaded if the gift changed. */
  window.ClarkUpsells = {
    checkGift: function () {
      return getCart().then(function (cart) {
        return ensureFreeGift(cart).then(function (changed) {
          if (!changed) return;
          if (document.body && document.body.classList.contains('template-cart')) window.location.reload();
          else refreshDrawer();
        });
      }).catch(function () {});
    }
  };

  function init() {
    if (window.__clarkUpsellsInit) return;
    window.__clarkUpsellsInit = true;
    ensureCss();
    var d = document.getElementById('drawerCart');
    var b = document.getElementById('drawerCartBody');
    if (b) new MutationObserver(reinsertBlocks).observe(b, { childList: true });
    if (d) new MutationObserver(schedule).observe(d, { childList: true, subtree: true });
    document.addEventListener('drawercart:open', schedule);
    schedule();
    /* page load: make sure the gift matches the cart (e.g. the cart was filled on another page) */
    setTimeout(function () { window.ClarkUpsells.checkGift(); }, 1200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
